import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { TagsManagerGridDataProviderFactory } from '../factory/TagsManagerGridDataProviderFactory';
import { TagsManagerGridBaseDataProvider } from '../dataProvider/TagsManagerGridBaseDataProvider';

export class TagsManagerGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: TagsManagerGridDataProviderFactory;
  public dataProvider: TagsManagerGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new TagsManagerGridDataProviderFactory(),
    });
  }

  public async getDataForView() {
    return this.dataProvider.getDataForView();
  }
}
